export const links = [
  {
    id: 1,
    name: "users",
    route: "/users",
    children: [],
  },
  {
    id: 2,
    name: "Thought Leaders",
    route: "/thought-leaders",
    children: [],
  },
  {
    id: 3,
    name: "Skills",
    route: "/skills",
    children: [],
  },
  {
    id: 5,
    name: "Courses",
    route: "/courses",
    children: [],
  },
  {
    id: 6,
    name: "Master Classes & Seminars",
    route: "/events",
    children: [],
  },
  {
    id: 4,
    name: "Free Classes",
    route: "/free-class",
    children: [],
  },
  {
    id: 7,
    name: "Groups",
    route: "/groups",
    children: [],
  },
  {
    id: 8,
    name: "Submissions",
    route: "/submissions",
    children: [],
  },
  {
    id: 8,
    name: "Discourse Activity",
    route: "/discourse-logs",
    children: [],
  },
  {
    id: 9,
    name: "Account Activity",
    route: "/account-activity",
    children: [],
  },
  {
    id: 10,
    name: "Request List",
    route: "/request-list",
    children: [],
  },
  {
    id: 11,
    name: "Contributors",
    route: "/contributors",
    children: [],
  },
  {
    id: 12,
    name: "Reports",
    route: "/subscriptions",
    children: [
      {
        id: 1,
        name: "Subscriptions / Purchases",
        route: "/subscriptions",
      },
      {
        id: 2,
        name: "Courses - All Courses",
        route: "/all-course",
      },
      {
        id: 3,
        name: "Courses - Individual course",
        route: "/all-individual_course",
      },
      {
        id: 4,
        name: "Users",
        route: "/userList",
      },
      {
        id: 5,
        name: "Free classes",
        route: "/freeClassList",
      },
    ],
  },
  {
    id: 13,
    name: "Applications",
    route: "/applications",
    children: [],
  },
  {
    id: 14,
    name: "Reports",
    route: "/application-submitted",
    children: [
      {
        id: 1,
        name: "Applications",
        route: "/application-submitted",
      },
      {
        id: 2,
        name: "Courses Enrollments",
        route: "/course-enrollment",
      },
      {
        id: 3,
        name: "Sales",
        route: "/all-individual_course",
      },
    ],
  }
];

export const SubLinks = [
  {
    id: 1,
    name: "Subscriptions / Purchases",
    route: "/subscriptions",
  },
  {
    id: 2,
    name: "Courses - All Courses",
    route: "/all-course",
  },
  {
    id: 3,
    name: "Courses - Individual course",
    route: "/all-individual_course",
  },
  {
    id: 4,
    name: "Users",
    route: "/userList",
  },
  {
    id: 5,
    name: "Free classes",
    route: "/freeClassList",
  },
];

export const skillUpLinks = [
  {
    id: 1,
    name: "users",
    route: "/users",
    children: [],
  },
  {
    id: 2,
    name: "Thought Leaders",
    route: "/thought-leaders",
    children: [],
  },
  {
    id: 3,
    name: "Skills",
    route: "/skills",
    children: [],
  },
  {
    id: 5,
    name: "Courses",
    route: "/courses",
    children: [],
  },
  {
    id: 6,
    name: "Master Classes & Seminars",
    route: "/events",
    children: [],
  },
  {
    id: 4,
    name: "Free Classes",
    route: "/free-class",
    children: [],
  },
  {
    id: 7,
    name: "Groups",
    route: "/groups",
    children: [],
  },
  {
    id: 8,
    name: "Submissions",
    route: "/submissions",
    children: [],
  },
  {
    id: 8,
    name: "Discourse Activity",
    route: "/discourse-logs",
    children: [],
  },
  {
    id: 9,
    name: "Account Activity",
    route: "/account-activity",
    children: [],
  },
  {
    id: 10,
    name: "Request List",
    route: "/request-list",
    children: [],
  },
  {
    id: 11,
    name: "Contributors",
    route: "/contributors",
    children: [],
  },
  {
    id: 12,
    name: "Reports",
    route: "/subscriptions",
    children: [
      {
        id: 1,
        name: "Subscriptions / Purchases",
        route: "/subscriptions",
      },
      {
        id: 2,
        name: "Courses - All Courses",
        route: "/all-course",
      },
      {
        id: 3,
        name: "Courses - Individual course",
        route: "/all-individual_course",
      },
      {
        id: 4,
        name: "Users",
        route: "/userList",
      },
      {
        id: 5,
        name: "Free classes",
        route: "/freeClassList",
      },
    ],
  },
];

export const preCollegeLinks = [
  {
    id: 1,
    name: "users",
    route: "/users",
    children: [],
  },
  {
    id: 2,
    name: "Thought Leaders",
    route: "/thought-leaders",
    children: [],
  },
  {
    id: 3,
    name: "Skills",
    route: "/skills",
    children: [],
  },
  {
    id: 5,
    name: "Courses",
    route: "/courses",
    children: [],
  },
  {
    id: 6,
    name: "Master Classes & Seminars",
    route: "/events",
    children: [],
  },
  {
    id: 4,
    name: "Free Classes",
    route: "/free-class",
    children: [],
  },
  {
    id: 7,
    name: "Groups",
    route: "/groups",
    children: [],
  },
  {
    id: 8,
    name: "Submissions",
    route: "/submissions",
    children: [],
  },
  {
    id: 8,
    name: "Discourse Activity",
    route: "/discourse-logs",
    children: [],
  },
  {
    id: 9,
    name: "Account Activity",
    route: "/account-activity",
    children: [],
  },
  {
    id: 10,
    name: "Request List",
    route: "/request-list",
    children: [],
  },
  {
    id: 11,
    name: "Contributors",
    route: "/contributors",
    children: [],
  },
  {
    id: 13,
    name: "Applications",
    route: "/applications",
    children: [],
  },
  {
    id: 14,
    name: "Reports",
    route: "/application-submitted",
    children: [
      {
        id: 1,
        name: "Applications",
        route: "/application-submitted",
      },
      {
        id: 2,
        name: "Courses",
        route: "/course-enrollment",
      },
      {
        id: 3,
        name: "Sales",
        route: "/sales",
      },
      // {
      //   id: 4,
      //   name: "Course",
      //   route: "/course-report",
      // },
    ],
  }
];

export const launchpadLinks = [
  {
    id: 1,
    name: "users",
    route: "/users",
    children: [],
  },
  {
    id: 2,
    name: "Thought Leaders",
    route: "/thought-leaders",
    children: [],
  },
  {
    id: 3,
    name: "Skills",
    route: "/skills",
    children: [],
  },
  {
    id: 5,
    name: "Courses",
    route: "/courses",
    children: [],
  },
  {
    id: 6,
    name: "Master Classes & Seminars",
    route: "/events",
    children: [],
  },
  {
    id: 4,
    name: "Free Classes",
    route: "/free-class",
    children: [],
  },
  {
    id: 7,
    name: "Groups",
    route: "/groups",
    children: [],
  },
  {
    id: 8,
    name: "Submissions",
    route: "/submissions",
    children: [],
  },
  {
    id: 8,
    name: "Discourse Activity",
    route: "/discourse-logs",
    children: [],
  },
  {
    id: 9,
    name: "Account Activity",
    route: "/account-activity",
    children: [],
  },
  {
    id: 10,
    name: "Request List",
    route: "/request-list",
    children: [],
  },
  {
    id: 11,
    name: "Contributors",
    route: "/contributors",
    children: [],
  },
];


export const  certificates = [
  {
    id: 1,
    name: "users",
    route: "/users",
    children: [],
  },
  {
    id: 2,
    name: "Thought Leaders",
    route: "/thought-leaders",
    children: [],
  },
  {
    id: 3,
    name: "Skills",
    route: "/skills",
    children: [],
  },
  {
    id: 5,
    name: "Certificate courses",
    route: "/courses",
    children: [],
  },
  {
    id: 11,
    name: "Contributors",
    route: "/contributors",
    children: [],
  },
  {
    id: 13,
    name: "Applications",
    route: "/applications",
    children: [],
  },
  {
    id:15,
    name :"Certificates",
    route: "/certificates",
    children: [],
  },
  {
    id: 14,
    name: "Reports",
    route: "/application-submitted",
    children: [
      {
        id: 1,
        name: "Applications",
        route: "/application-submitted",
      },
      {
        id: 2,
        name: "Courses",
        route: "/course-enrollment",
      },
      {
        id: 3,
        name: "Sales",
        route: "/sales",
      },
      // {
      //   id: 4,
      //   name: "Course",
      //   route: "/course-report",
      // },
    ],
  }
]


export const  dlPprogram = [
  {
    id: 1,
    name: "users",
    route: "/users",
    children: [],
  },
  {
    id: 2,
    name: "applicants",
    route: "/applicants",
    children: [],
  },
  {
    id: 2,
    name: "Thought Leaders",
    route: "/thought-leaders",
    children: [],
  },
  {
    id: 11,
    name: "Contributors",
    route: "/contributors",
    children: [],
  },
  {
    id: 13,
    name: "Program",
    route: "/program",
    children: [],
  },
  {
    id: 14,
    name: "Events",
    route: "/event",
    children: [],
  },
  {
    id: 13,
    name: "Applications",
    route: "/applications",
    children: [],
  },
  {
    id: 14,
    name: "Reports",
    route: "/dl-application-submitted",
    children: [
      {
        id: 1,
        name: "Applications",
        route: "/dl-application-submitted",
      },
    ],
  }
]